import React, { Component } from 'react';
// import axios from 'axios';
// import Select from 'react-select'

// import Custom Componenets
import Breadcrumb from '../common/breadcrumb.component';
import BootstrapTable from 'react-bootstrap-table-next';
import Modal from 'react-responsive-modal';
import { Button, Form, FormGroup, Label, Col } from 'reactstrap';
import SweetAlert from 'react-bootstrap-sweetalert';

// import Editor from 'ckeditor5-custom-build/build/ckeditor';
import "react-datetime/css/react-datetime.css";
import moment from 'moment';

// koneksi
import { GetLanding } from '../../function/Koneksi';

const formInput = {
	uuid: '',
	type: '',
	nama: '',
	nomor_whatsapp: '',
	ipAddress: '',
	city: '',
	stateProv: '',
	kategori: '',
	pesan: '',
}

class Bumdes extends Component {

	constructor(props) {
		super(props);
		this.loader = props;
		const hari = new Date();
		this.state = {
			data: [],
			pagination: [],
			status: {
				form: false,
				btnForm: false,
				btnAksi: false,
				detail: false,
				share: false,
			},
			awal: "",
			sebelum: "",
			hal: [],
			setelah: "",
			akhir: "",
			dt: formInput,
			judul: "Kirim Pesan Whatsapp",
			alert: null,
			show: false,
			basicTitle: '',
			basicType: "default",
			pesanAlert: '',
			dataCari: '',
			loadingPreview: false,
			//ckeditor
			content: '',
			responnya: [],
			
			frmJenisApp: [],
			selectedMonth: hari.getMonth() + 1,
			selectedYear: hari.getFullYear(),
			filterData: moment(hari).format('YYYY/MM')
		};
	}

	// ================== Sweet Alert ==================
	closeAlert = () => {
		this.setState({
			show: false
		});
	}

	onRecieveInput = (value) => {
		this.setState({
			alert: (
				<SweetAlert success title="Nice!" onConfirm={this.hideAlert}>
					You wrote: {value}
				</SweetAlert>
			)
		});
	}

	hideAlert = () => {
		this.setState({
			alert: null
		});
	}

	// =================================================

	// ================== Ambil data dari db untuk table ==================
	fetch = (params = {}) => {
		this.setState({
			loadingPreview: true,
		})
		let link = "";
		if (params.page) {
			switch (params.page) {
				case ">>":
				  link =
					"?page=" +
					Math.ceil(
					  this.state.pagination.total / this.state.pagination.per_page
					);
				  break;
				case ">":
				  link = "?page=" + (parseInt(this.state.pagination.current_page) + 1);
				  break;
				case "<":
				  link = "?page=" + (parseInt(this.state.pagination.current_page) - 1);
				  break;
				case "<<":
				  link = "?page=1";
				  break;
				default:
				  link = "?page=" + params.page;
				  break;
			  }
		}

		// if(params.page){
		// 	link = link + '&q=' + this.state.dataCari + `&month=${this.state.selectedMonth}&year=${this.state.selectedYear}`
		// }
		// else{
		// 	link = link + '?q=' + this.state.dataCari + `&month=${this.state.selectedMonth}&year=${this.state.selectedYear}`
		// }

		const { dataCari, selectedMonth, selectedYear } = this.state;

		if(params.page){
			link = link+`&sort_field=created_at&order_by=ASC&q=${dataCari}&month=${selectedMonth}&year=${selectedYear}`;
		}
		else{
			link = `?sort_field=created_at&order_by=ASC&q=${dataCari}&month=${selectedMonth}&year=${selectedYear}`;
		}


		GetLanding('data-click' + link, null, (lihat) => {
			if (lihat.results.data) {
				this.setState({ 
					data: lihat.results.data, 
					pagination: lihat.results,
					loadingPreview: false
				});
				this.pagination(lihat.results);
			}
			else{
				this.setState({ loadingPreview: false, });
			}
		});
	}

	// Pagination
	pagination = (data, tab) => {
		let awal = "";
		let hal = [];
		let sebelum = "";
		let setelah = "";
		let akhir = "";
		if (data.total > 0) {
		  let start = 1;
		  let end = 5;
		  let n = 0;
		  let p = 0;
		  if (data.current_page <= 3) {
			start = 1;
			end = 5;
			if (data.last_page > data.current_page) {
			  n = data.current_page + 1;
			}
		  } else {
			p = data.current_page - 1;
			n = data.current_page + 1;
			start = data.current_page - 2;
			end = data.current_page + 2;
		  }
		  if (end >= data.last_page - 2) {
			p = data.current_page - 1;
			if (start >= 5) {
			  start = data.last_page - 4;
			}
			end = data.last_page;
		  }
	
		  for (let i = start; i <= end; i++) {
			let warna = "success";
			if (i === data.current_page) {
			  warna = "danger";
			}
			hal.push(
			  <a
				href={() => false}
				key={i}
				onClick={() => this.fetch({ page: i, tab: tab })}
				className={
				  "btn btn-" + warna + " btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
				}
			  >
				{i}
			  </a>
			);
		  }
		  if (p > 0) {
			sebelum = (
			  <a
				href={() => false}
				onClick={() => this.fetch({ page: p, tab: tab })}
				className="btn btn-success btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
			  >
				{"<"}
			  </a>
			);
		  }
		  if (n > 0) {
			setelah = (
			  <a
				href={() => false}
				onClick={() => this.fetch({ page: n, tab: tab })}
				className="btn btn-success btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
			  >
				{">"}
			  </a>
			);
		  }
	
		  awal = (
			<a
			  href={() => false}
			  onClick={() => this.fetch({ page: 1, tab: tab })}
			  className="btn btn-success btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
			>
			  {"<<"}
			</a>
		  );
		  akhir = (
			<a
			  href={() => false}
			  onClick={() => this.fetch({ page: data.last_page, tab: tab })}
			  className="btn btn-success btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
			>
			  {">>"}
			</a>
		  );
		}
	
		
		this.setState({ awal, sebelum, hal, setelah, akhir });
		
	};

	// Cari Data Table
	cariData = e => {
		if (e.key === 'Enter') {
			this.setState({ dataCari: e.target.value }, () => {
				this.fetch();
			});
		}
	}

	handleInputChange = (e, fld) => {
		this.setState({
			dt:{
				...this.state.dt,
				[fld]: e.target.value
			}
		});
	};

	handleSelectChange = (e, data) => {
		if (e) {
			this.setState({ 
				dt:{
					...this.state.dt,
					[data]: { value: e.value, label: e.label }
				}
			});
		} else {
			this.setState({ 
				dt:{
					...this.state.dt,
					[data]: "",
				}
			});
		}
	}

	// handleDateChange = (date) => {
	// 	const formattedDate = moment(date).format('YYYY-MM');
	// 	const [year, month] = formattedDate.split('-');

	// 	this.setState(
	// 		{
	// 			selectedMonth: parseInt(month),
	// 			selectedYear: parseInt(year),
	// 			filterData: moment(date).format('YYYY/MM')
	// 		},
	// 		() => {
	// 			this.fetch();
	// 		}
	// 	);
	// };

	handleMonthChange = (event) => {
		this.setState({ selectedMonth: parseInt(event.target.value) }, () => {
			this.fetch();
		});
	};
	
	handleYearChange = (event) => {
		this.setState({ selectedYear: parseInt(event.target.value) }, () => {
			this.fetch();
		});
	};

	Share = (data) => {
		this.setState.judul = "Detail Data Klik";
		this.setState({
			status:{
				form: true,
				share: true,
			},
			dt:{
				uuid: data.uuid,
				type: data.type,
				nama: data.nama,
				nomor_whatsapp: data.nomor_whatsapp,
				ipAddress: data.ipAddress,
				city: data.city,
				stateProv: data.stateProv,
				kategori: data.kategori,
			}
		})
		this.forceUpdate();
		this.bukaForm('share');
	}

	handleShareSubmit = () => {
		const { nomor_whatsapp, pesan } = this.state.dt;

		let status = false;
		let set_nomor = nomor_whatsapp;
		if (nomor_whatsapp.charAt(0) === "0") {
			set_nomor = "62" + nomor_whatsapp.slice(1);
			status = true;
		} else if (nomor_whatsapp.slice(0,2) === "62") {
			set_nomor = nomor_whatsapp;
			status = true;
		}

		if (status === true) {
			const phone = encodeURIComponent(set_nomor);
			const message = encodeURIComponent(pesan);
	
			console.log('wa');
			console.log(phone);
			console.log(message);
			
		
			const waLink = `https://api.whatsapp.com/send?phone=${phone}&text=${message}`;
		
			window.open(waLink, '_blank');

			this.setState({ 
				loadingPreview: false,
				show: true, 
				basicType: 'success', 
				basicTitle: 'Berhasil Mengirim', 
				pesanAlert: 'Pesan Berhasil Dikirim',
				status: {
					form: false,
					btnForm: false,
					btnAksi: false,
					detail: false,
					share: false,
				},
				dt: formInput,
			});
			this.forceUpdate();
		}
		else{
			this.setState({ 
				loadingPreview: false,
				show: true, 
				basicType: 'warning', 
				basicTitle: 'Gagal Mengirim', 
				pesanAlert: 'Format Nomor Tidak Sesuai',
				status: {
					form: false,
					btnForm: false,
					btnAksi: false,
					detail: false,
					share: false,
				},
				dt: formInput,
			});
			this.forceUpdate();
		}

	};

	bukaForm = (e) => {
		if (e === 'tambah') {
			this.setState({
				dt:formInput,
			})
		}
		this.setState({
			status:{
				...this.state.status,
				form: true,
			}
		})
		this.forceUpdate();
	}

	tutupForm = () => {
		this.setState({
			status: {
				form: false,
				btnForm: false,
				btnAksi: false,
				detail: false,
				share: false,
			},
			dt: formInput,
		})
		this.forceUpdate();
	}

	tombolAksi = (cell, row) => {
		return (
			<>
				<Button size="xs" color="warning" className="btn-eye" onClick={() => this.Share(row)}><i className="fa fa-share"></i></Button> &nbsp;&nbsp;
			</>
		)
	}
	componentDidMount() {
		this.fetch({ page: null, where: [] });
	}

	render() {
		var data = this.state.data;

		const columns = [
			{
				dataField: "no",
				text: "No",
				isDummyField: true,
				csvExport: false,
				headerAlign: 'center',
						align: 'center',
				formatter: (key, obj, index) =>{          
					let current_pagenum = this.state.pagination.current_page;
					let total_records_per_page = this.state.pagination.per_page;
					let row_index = (index+1);
					let serial_num = ((total_records_per_page*(current_pagenum-1))+row_index);
					return serial_num; 
				}
			},
			{
				dataField: "created_at",
				text: "Tanggal",
				headerAlign: 'center',
				align: 'center',
				sort: true,
				formatter: (cell) => {
					if (!cell) return '-';
					
					const tgl = new Date(cell);
					const hari = tgl.getDate();
					const listbulan = [
						'Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni',
						'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember'
					];
					const bulan = listbulan[tgl.getMonth()];
					const tahun = tgl.getFullYear();
					const jam = tgl.getHours().toString().padStart(2, '0');
					const menit = tgl.getMinutes().toString().padStart(2, '0');
					const detik = tgl.getSeconds().toString().padStart(2, '0');
					
					return `${hari} ${bulan} ${tahun}, ${jam}:${menit}:${detik}`;
				}
			},
			{
				dataField: 'type',
				text: 'Type',
				headerAlign: 'center',
				align: 'center',
				sort: true
			},
			{
				dataField: 'nama',
				text: 'Nama',
				headerAlign: 'center',
				sort: true
			},
			{
				dataField: 'kategori',
				text: 'Kategori',
				headerAlign: 'center',
				align: 'center',
				sort: true
			},
			{
				dataField: 'lokasi',
				text: 'Lokasi',
				headerAlign: 'center',
				align: 'center',
				sort: true,
				formatter: (cell, obj) => {
					const city = obj.city || '-';
					const stateProv = obj.stateProv || '-';
					return `${city}, ${stateProv}`;
				}
			},
			{
				dataField: 'nomor_whatsapp',
				text: 'Nomor Whatsapp',
				headerAlign: 'center',
				align: 'center',
				sort: true
			},
			{
				dataField: 'aksi',
				text: 'Aksi',
				headerAlign: 'center',
				align: 'center',
				isDummyField: true,
				csvExport: false,
				formatter: this.tombolAksi,
			},
		];

		return (
			<div>
				<Breadcrumb title="Data Klik" parent="Admin" />
				<SweetAlert
					show={this.state.show}
					type={this.state.basicType}
					title={this.state.basicTitle}
					confirmBtnBsStyle="success"
					onConfirm={this.closeAlert}
				>
					{this.state.pesanAlert}
				</SweetAlert>

				{this.state.alert}

				<div className="container-fluid">
					<div className="row">
						<div className="col-sm-12">
							<div className="card mb-0">
								<div className="card-body datatable-react">
									<div className="row">
										<div className="col-sm-6">
											<input
												type="search"
												className="form-control"
												id="cariTable"
												placeholder="Cari Disini..."
												defaultValue={this.state.dataCari}
												onKeyPress={this.cariData}
											/>
										</div>
										{/* <div className="col-sm-6 text-right">
											<Datetime
												inputProps={{ placeholder: 'Pilih Tanggal', required: true }}
												inputId="tanggal"
												name="tanggal"
												locale="id-ID"
												timeFormat={false}
												dateFormat="YYYY/MM"
												closeOnTab={true}
												closeOnSelect={true}
												initialValue={new Date()}
												value={this.state.filterData}
												onChange={this.handleDateChange}
											/>
										</div> */}
										<div className="col-sm-3">
											<select
												className="form-control"
												value={this.state.selectedMonth}
												onChange={this.handleMonthChange}
											>
												{[...Array(12)].map((_, index) => (
													<option key={index + 1} value={index + 1}>
														{moment().month(index).format('MMMM')}
													</option>
												))}
											</select>
										</div>
										<div className="col-sm-3">
											<select
												className="form-control"
												value={this.state.selectedYear}
												onChange={this.handleYearChange}
											>
												{[...Array(10)].map((_, index) => {
													const year = new Date().getFullYear() - 5 + index;
													return (
														<option key={year} value={year}>
															{year}
														</option>
													);
												})}
											</select>
										</div>
									</div>

									<BootstrapTable
										keyField="uuid"
										data={data}
										columns={columns}
									/>
									<div className="pull-right text-white">
										{this.state.awal}
										{this.state.sebelum}
										{this.state.hal.map((dt) => {
											return dt;
										})}
										{this.state.setelah}
										{this.state.akhir}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<br />
				{/* Loading preview */}
				<SweetAlert
					show={this.state.loadingPreview}
					showCancel = {false}
					showConfirm={false}
				>
					<div align="center">
						<h5 className="modal-title" style={{ textAlign: "center", color: 'black' }}>Sedang memuat data...</h5>
						<br/>
						<img 
							alt="loading"
							src={require("../../assets/images/tes-loading.gif")} 
							style={{
								// width: "100%",
								borderRadius: "10px",
								width: '150px'
							}}
						/> 
						<br/><br/>
					</div>
				</SweetAlert>
				
				<Modal styles={{ modal: { width: "75%", maxWidth: 'unset' } }} open={this.state.status.form} onClose={this.tutupForm} closeOnEsc={false} closeOnOverlayClick={false}>
					<Form className="theme-form">
						<div className="modal-header">
							<h5 className="modal-title">{this.state.judul}</h5>
						</div>
							<input className="form-control" id="uuid" type="hidden" placeholder="UUID" defaultValue={this.state.dt.uuid} />
							{this.state.status.share ? (
							<div className="modal-body">
								<FormGroup className="row">
									<Label className="col-sm-3 col-form-label" htmlFor="keterangan">Pesan</Label>
									<Col sm="9">
									<textarea
										className="form-control"
										id="pesan"
										placeholder="Silahkan Masukkan Pesan"
										value={this.state.dt.pesan}
										onChange={(e) => this.handleInputChange(e, 'pesan')}
										required
									/>
									</Col>
								</FormGroup>
							</div>
						) : (
							<div className="modal-body">
							<FormGroup className="row">
								<Label className="col-sm-3 col-form-label" htmlFor="inputEmail3">Username</Label>
								<Col sm='9'>
									<input 
										className="form-control" 
										id="username" 
										type="text" 
										defaultValue={this.state.dt.username} 
										onChange={e => this.handleInputChange(e, "username")}
										required={true}
										readOnly={this.state.status.detail?true:false}
										style={this.state.status.detail ? { backgroundColor: "#F2F2F2" } : { backgroundColor: "" }}
									/>
								</Col>
							</FormGroup>
							<FormGroup className="row">
								<Label className="col-sm-3 col-form-label" htmlFor="inputEmail3">Nama Bumdes</Label>
								<Col sm='9'>
									<input 
										className="form-control" 
										id="nama_bumdes" 
										type="text" 
										defaultValue={this.state.dt.nama_bumdes} 
										onChange={e => this.handleInputChange(e, "nama_bumdes")}
										required={true}
										readOnly={this.state.status.detail?true:false}
										style={this.state.status.detail ? { backgroundColor: "#F2F2F2" } : { backgroundColor: "" }}
									/>
								</Col>
							</FormGroup>
							<FormGroup className="row">
								<Label className="col-sm-3 col-form-label" htmlFor="inputEmail3">Alamat Bumdes</Label>
								<Col sm='9'>
									<input 
										className="form-control" 
										id="alamat_bumdes" 
										type="text" 
										defaultValue={this.state.dt.alamat_bumdes} 
										onChange={e => this.handleInputChange(e, "alamat_bumdes")}
										required={true}
										readOnly={this.state.status.detail?true:false}
										style={this.state.status.detail ? { backgroundColor: "#F2F2F2" } : { backgroundColor: "" }}
									/>
								</Col>
							</FormGroup>
							<FormGroup className="row">
								<Label className="col-sm-3 col-form-label" htmlFor="inputEmail3">Nama Pemohon</Label>
								<Col sm='9'>
									<input 
										className="form-control" 
										id="nama_pemohon" 
										type="text" 
										defaultValue={this.state.dt.nama_pemohon} 
										onChange={e => this.handleInputChange(e, "nama_pemohon")}
										required={true}
										readOnly={this.state.status.detail?true:false}
										style={this.state.status.detail ? { backgroundColor: "#F2F2F2" } : { backgroundColor: "" }}
									/>
								</Col>
							</FormGroup>
						</div>
						)}
						<div className="modal-footer">
							{
								this.state.status.share? 
								<>
									<button type="button" className="btn btn-warning" disabled={this.state.status.btnForm} onClick={this.tutupForm}>Tutup</button>
									<button type="submit" className="btn btn-success" onClick={this.handleShareSubmit}>Share</button>
								</>
								:
								this.state.status.detail?
								<button type="button" className="btn btn-warning" disabled={this.state.status.btnForm} onClick={this.tutupForm}>Tutup</button>
								:
								<></>
							}
						</div>
					</Form>
				</Modal>
			</div>
		)
	}
}


export default Bumdes;
